<template>
  <div class="login">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              title="登录用户"
              fixed
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--输入框-->
    <div>
      <van-cell-group>
        <van-field v-model="phone" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="password" label="密码" type="password" placeholder="请输入密码" />
      </van-cell-group>
    </div>
    <div style="width: 80%; margin:10px auto 0 auto;">
      <van-button type="primary" block @click="setLogin">登录</van-button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    'name': 'Login',
    data() {
        return {
            phone: '',
            password: ''
        };
    },
    // 组件内守卫
    beforeRouteEnter:(to,from,next) => {
        if (localStorage.getItem('access_token')){
            next(vm => vm.$router.push({path:'/home'}));
        }else{
            next();
        }
    },
    methods: {
        ...mapActions(['requestLogin']),
        onClickLeft() {
            this.$router.push({path: '/home'});
        },
        setLogin() {

          if (this.phone=== ''){
              this.$toast('手机号必填');
              return false;
          };
          if (this.password=== ''){
              this.$toast('密码必填');
              return false;
          };

          // 登录提示，组装数据区
          const loginToast = this.$toast.loading({
              mask: true,
              message: '正在登录中...',
              duration:0
          });

          let data = {
              phone: this.phone,
              password: this.password
          }

          // vuex 处理逻辑
          this.requestLogin({"data":data,"thit":this,"loginToast":loginToast});

        }
    }
};
</script>

<style scoped>
.login >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.login >>> .van-nav-bar__text {
  color: #fff;
}
.login >>> .van-nav-bar__title {
  color: #fff;
}
.login >>> .van-nav-bar .van-icon {
  color: #fff;
}
.login >>> .van-button--primary {
  color: #fff;
  background-color: #ff8917;
  border: 0.02667rem solid #ff8917;
}
</style>
